<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <app-title>Domains List</app-title>
            <v-expansion-panel expand popout>
              <v-expansion-panel-content v-for="(dom, index) in domains" :key="index">
                <div slot="header">
                  <app-title>
                    {{dom.name}} - Extensions: {{dom.extensions}}
                    <v-btn color="success" @click="chooseDomain(dom.name)">Edit</v-btn>
                  </app-title>
                </div>
                <div>
                  <v-container fluid>
                    <extension-detail
                      v-if="domain.name == dom.name"
                      v-for="(ext, index) in domain.extDetails"
                      :key="index"
                      :extension="ext"
                      @save="save"
                    ></extension-detail>
                  </v-container>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import globalMixin from "@/mixins/globalMixin";
import extensionDetail from "@/components/nampt/extensionDetail";
export default {
  name: "pbxExtensions",
  mixins: [globalMixin],
  components: {
    extensionDetail
  },
  data() {
    return {
      extensions: [],
      domains: [],
      domain: { name: null, extDetails: [] }
    };
  },
  methods: {
    ...mapActions("nampt", ["getExtensions", "getDomains", "saveExtension"]),
    save(val) {
      let dom = this.domains.filter(x => x.name == this.domain.name)[0];
      let query = { domain: dom, extension: val };
      this.saveExtension(query)
        .then(data => {
          console.log(data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    retrieveDomains() {
      this.getDomains().then(data => {
        this.domains = data;
      });
    },
    chooseDomain(val) {
      this.domain = val;
      this.$emit("domainSelected", val);
      this.getExtensions(val).then(data => {
        this.domain = { name: val, extDetails: data };
      });
    }
  },
  computed: {
    headers() {
      if (this.extensions.length > 0)
        return this.getHeaders(this.extensions[0]);
      else return null;
    }
  },
  mounted() {
    this.retrieveDomains();
  }
};
</script>

